import React, { useEffect, useRef } from 'react';
import Translate from '../general/translate';

const Asseenon = () => {
  const logosRef = useRef(null);

  useEffect(() => {
    const ul = logosRef.current;
    const clone = ul.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    ul.parentNode.appendChild(clone);
  }, []);

  return (
    <div className="bg-[#27004F] py-8 px-0">
      <div className="container mx-auto w-full">        
        <div className="w-full inline-flex flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
          <ul ref={logosRef} className="opacity-90 flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll">
            <li>
              <img src="/asseenon/podnews.webp" alt={<Translate id="podnews.logo" foldername="general" filename="asseenon" />} className="w-44" />
            </li>
            <li>
              <img src="/asseenon/transistorlogo.webp" alt={<Translate id="transistor.logo" foldername="general" filename="asseenon" />} className="w-44" />
            </li>
            <li>
              <img src="/asseenon/thepodcasthost.webp" alt={<Translate id="thepodcasthost.logo" foldername="general" filename="asseenon" />} className="w-44" />
            </li>
            <li>
              <img src="/asseenon/schoolofpodcasting.webp" alt={<Translate id="schoolofpodcasting.logo" foldername="general" filename="asseenon" />} className="w-44" />
            </li>
            <li>
              <img src="/asseenon/semrush.webp" alt={<Translate id="semrush.logo" foldername="general" filename="asseenon" />} className="w-44" />
            </li>
            <li>
              <img src="/asseenon/businessinsider.webp" alt="Business Insider" className="w-32" />
            </li>
            {/* Duplicate the list items here for seamless scrolling */}
            <li>
              <img src="/asseenon/podnews.webp" alt={<Translate id="podnews.logo" foldername="general" filename="asseenon" />} className="w-44" />
            </li>
            <li>
              <img src="/asseenon/transistorlogo.webp" alt={<Translate id="transistor.logo" foldername="general" filename="asseenon" />} className="w-44" />
            </li>
            <li>
              <img src="/asseenon/thepodcasthost.webp" alt={<Translate id="thepodcasthost.logo" foldername="general" filename="asseenon" />} className="w-44" />
            </li>
            <li>
              <img src="/asseenon/schoolofpodcasting.webp" alt={<Translate id="schoolofpodcasting.logo" foldername="general" filename="asseenon" />} className="w-44" />
            </li>
            <li>
              <img src="/asseenon/semrush.webp" alt={<Translate id="semrush.logo" foldername="general" filename="asseenon" />} className="w-44" />
            </li>
            <li>
              <img src="/asseenon/businessinsider.webp" alt="Business Insider" className="w-32" />
            </li>
          </ul>
        </div>
      </div>
      <style jsx>{`
        @keyframes infinite-scroll {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-infinite-scroll {
          display: flex;
          animation: infinite-scroll 25s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Asseenon;